/* eslint-disable react/jsx-no-constructed-context-values */
import PropTypes from 'prop-types';
import { Component, createContext } from 'react';
import { setupStreamNotifications } from 'services/StreamService';
import { UserContext } from 'components/providers/UserProvider/UserProvider';

/**
 * For setting up custom contexts to user GetStream Notifications
 * @type {React.Context<import('@components/layout/Header/Notifications/types').NotificationsContextType>}
 */
export const NotificationsContext = createContext({
  realtimeEventCount: 0,
  setProperty: () => {},
  streamNotificationsFeed: null,
  unseenCount: 0,
});

/**
 * Provider for notifications related behavior, current purpose is to act as
 * a provider for custom GetStream notifications web sockets
 */
class NotificationsProvider extends Component {
  constructor (props) {
    super(props);

    this.state = {
      realtimeEventCount: 0,
      streamNotificationsFeed: null,
      unseenCount: props.unseenCount || 0,
    };

    this.isUnmounted = false;
    this.setProperty = this.setProperty.bind(this);
  }

  /**
   * Sets up the GetStream feed and its token refresh. If the provider unmounted while setup was in flight,
   * stops what setup just started.
   */
  async componentDidMount () {
    this.stopStreamNotifications = await setupStreamNotifications(this, this.props.user);

    if (this.isUnmounted) this.stopStreamNotifications?.();
  }

  componentWillUnmount () {
    this.isUnmounted = true;
    this.stopStreamNotifications?.();
  }

  setProperty (property) {
    this.setState(property);
  }

  render () {
    return (
      <NotificationsContext.Provider
        value={{
          ...this.state,
          setProperty: this.setProperty
        }}
      >
        {this.props.children}
      </NotificationsContext.Provider>
    );
  }
}

NotificationsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const exportedComponent = props => (
  <UserContext.Consumer>
    {user => <NotificationsProvider {...props} user={user} />}
  </UserContext.Consumer>
);

export default exportedComponent;
